import { render, staticRenderFns } from "./ContactPhoneNumberList.vue?vue&type=template&id=4b3ba706"
import script from "./ContactPhoneNumberList.vue?vue&type=script&lang=js"
export * from "./ContactPhoneNumberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports